import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'paq72',
  Description:
    'Here\'s all the online content included with your <strong>Physics Exam Practice Workbook</strong>.',
  Credits:
    '<p><strong>Exam Practice Questions</strong></p>' +
    'Contributors: Stuart Burditt, Oliver Rigg, Frances Rooney, Sam Pilgrim, and Laura Morris.<br>' +
    'With thanks to Mark Edwards and Josie Gilbert for the proofreading.<br>' +
    'Illustrations by: Sandy Gardner Artist, email sandy@sandygardner.co.uk<br>' +
    'Clipart from Corel&reg;' +
    '</p>' +
    '<p>Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</p>',};